import React from 'react';
import Modal from 'modal-enhanced-react-native-web';
import { View } from 'react-native';
export default function aModal({ backButtonClose, onClosed, isOpen, style, ...restProps }) {
	return <Modal {...restProps} style={[{margin:'auto'}, style, { maxWidth: 600 }]} isVisible={isOpen} onBackdropPress={backButtonClose && onClosed} />;
}
